import { Component, input } from '@angular/core';
import Campaign from '../../../models/KB Layer/campaign';

@Component({
  selector: 'app-campaign-card-component',
  standalone: true,
  templateUrl: './campaign-card-component.html',
  styleUrl: './campaign-card-component.css',
})
export class CampaignCardComponent {
  readonly campaign = input.required<Campaign>();
  readonly universeName = input.required<string>();
}
